<template>
    <div class="video-external spalla-container">
        <div class="container" v-if="spalladata.spallaTexts">

            <LeftTopButton @close-button="closeSpalla" />

            <p class="approfondimento-label">
                <span v-if="lang === 'it'">Approfondimento</span>
                <span v-if="lang === 'en'">Insight</span>
                <span v-if="lang === 'de'">Vertiefung</span>
            </p>
            
            <h2 class="title" v-if="spalladata.spallaTitle">{{ spalladata.spallaTitle }}</h2>
            
            <div class="content" v-for="(text, index) in finalTexts" :key="'spallatext'+index">
                <h3 v-if="text.attributes.field_ui_text_titolo">
                    {{ text.attributes.field_ui_text_titolo.value }}
                </h3>

                <p v-if="text.attributes.field_text_with_summary" 
                    v-html="text.attributes.field_text_with_summary.summary">
                </p>

                <p v-if="text.attributes.field_text_with_summary" 
                    v-html="text.attributes.field_text_with_summary.value">
                </p>
            </div>

            <figure v-for="(img, index) in spalladata.spallaContent[spalladata.spallaImages]" :key="'spallaimg'+index">
                <images showcaption :imagedata="spalladata.spallaContent" :fieldname="spalladata.spallaImages" :resultindex="index" :breakstyles="{'0': 'md_image', '768': 'lg_image'}"></images>
            </figure>

        </div>
    </div>
</template>

<script>
import Images from '../components/Images.vue'
import LeftTopButton from '../components/LeftTopButton.vue'
export default {
    props: { 
        spalladata: Object
    },
    components: {
        Images,
        LeftTopButton
    },
    computed: {
        lang() {
            return this.$store.state.currentLang
        },
        defaultLang() {
            return this.$store.state.defaultLang
        },
        finalTexts() {
            return this.spalladata.spallaContent[this.spalladata.spallaTexts].filter(f => f.attributes.field_tipo ==  this.spalladata.spallaTipo)
        }
    },
    methods: {
        closeSpalla() {
            document.body.classList.remove("noscroll")
            this.$emit('close-spalla')
        },
        srcImage(r) {
            return process.env.VUE_APP_ENDPOINT + r.attributes.uri.url
        }
    },
    mounted() {
        //console.log(this.spalladata)
        document.body.classList.add("noscroll")
    }
}
</script>

<style lang="scss" scoped>
@import "../styles/variables.scss";

div.spalla-container {
    background-color: #181923;
    .container {
        background-color: transparent;

        .approfondimento-label {
            color: #C79641;
            text-transform: uppercase;
            text-align: center;
            font-size: 16px;
            margin:0 ;
            margin-bottom: 6px;
        }
        h2 {
            text-align: center;
            color: #fff;
            font-weight: 300;
            line-height: 2rem;
            font-size: 24px;
            font-family: "Martel";
        }

        .content,
        .content ::v-deep * {
            color: #fff;
        }
    }
}


.video-external {
    position: fixed;
    width: 100%;
    height: 100%;
    bottom: 0;
    z-index: 9;
    max-width: 1024px;
    overflow-y: scroll;
    overflow-x: hidden;

    .container {
        background: #fff;
        padding: calc(102px + 80px) 1em 1em 1em;
        margin: 0;
        max-width: unset;
        min-height: calc(100% - 80px - 1em);
        position: relative;

      
        .title { margin-top: 0; }
        figure {
            margin: 2rem auto;
        }
    }

    ::v-deep picture img, 
    img {
        width: 100%;
        height: 100%;
        max-height: 300px;
        object-fit: contain;
    }
}

</style>